export default __webpack_public_path__ + "static/media/269.12332638.jpg";